<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:31:30
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">消息通知</div>
    <div class="my-content">
      <el-table
        v-loading="isLoading"
        :data="tableData"
        class="mt20"
      >
        <el-table-column label="标题" prop="Title" align="left" min-width="400">
        </el-table-column>
        <el-table-column label="时间" prop="AddTime" width="400" align="center">
        </el-table-column>
        <el-table-column prop="address" label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="hanldDetail(scope.row)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>

      <el-dialog
        title="查看"
        
        :visible.sync="dialogSshow"
        :append-to-body="true"
        class="width510"
      >
        <div class="my-info">
          <div class="my-info-item">
            <div class="my-info-item-title">通知标题：</div>
            <div class="my-info-item-content">{{ info.Title }}</div>
          </div>
          <div class="my-info-item">
            <div class="my-info-item-title">通知时间：</div>
            <div class="my-info-item-content">{{ info.AddTime }}</div>
          </div>
          <div class="my-info-item">
            <div class="my-info-item-title">内容：</div>
          </div>
          <div class="content-body" v-html="info.Body"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GetNoticeDetail, GetNoticeList } from "@/api/member";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "msg",
  data() {
    return {
      dialogSshow: false,
      isLoading: true,
      total: 0,
      info: {},
      tableData: [],
      getListData: {
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    hanldDetail(data) {
      GetNoticeDetail({ NoticeID: data.NoticeID }).then((res) => {
        this.info = res.data;
        this.dialogSshow = true;
      });
    },
    getList() {
      this.isLoading = true;
      const data = this.getListData;
      GetNoticeList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-info {
  .my-info-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .my-info-item-title {
      width: 100px;
      font-weight: 400;
      font-size: 18px;
      text-align: right;
      color: #666666;
    }
    .my-info-item-content {
      color: #333333;
      font-weight: 400;
      font-size: 18px;
    }
 
    .bold {
      color: #333333;
    }
    .Amount {
      font-weight: bold;
      font-size: 20px;
      color: #e12a14;
    }
  }
}
.content-body{
      padding: 10px;
      overflow: hidden;
      img{
        max-width: 100%;
      }
    }
.TotalAmount {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}
.price {
  font-weight: bold;
  font-size: 20px;
  color: #333333;
}
.Amount {
  font-weight: bold;
  font-size: 20px;
  color: #e12a14;
}
.width510 {
  ::v-deep .el-dialog {
    width: 900px;
  }
}
.my-search-box {
  position: relative;
  .my-search {
    width: 251px;
  }
}
.el-select,
.el-date-editor {
  ::v-deep .el-input__inner {
    width: 201px;
    height: 47px;
    background: #f6f8fc;
    border-radius: 23px;
    border: 1px solid #e6e6e6;
  }
}
</style>
